import type { FC } from 'react';

import { getCommunityChannelIcon } from '../utils/getCommunityChannelIcon';

interface CommunityChannelIconProps {
  slug?: string | null;
  emoji?: string | null;
  className?: string;
}

export const CommunityChannelIcon: FC<CommunityChannelIconProps> = ({ slug, emoji, className }) => {
  if (emoji) {
    return (
      <svg viewBox="0 0 100 100" className={className} aria-hidden="true">
        <text x="50" y=".9em" fontSize="90" textAnchor="middle">
          {emoji}
        </text>
      </svg>
    );
  }

  const Icon = getCommunityChannelIcon(slug);
  return <Icon className={className} aria-hidden="true" />;
};
